<template>
  <ElContainer class="content-layout">
    <ElMenu
      class="menu-list"
      :default-active="selectMenus"
      :unique-opened="true"
      :collapse="isCollapse"
      @select="handleselect"
    >
      <ElScrollbar class="menu-scrollbar">
        <ElMenuItem index="/home/person-center" class="menu_max_width">
          <SvgIcon name="logo" :size="26" color="#fff" />
          <template #title>
            <img class="logo_title" src="@/assets/images/logo_title.png" />
          </template>
        </ElMenuItem>
        <template v-for="item in menuList" :key="item.path">
          <ElSubMenu
            :index="item.path"
            :class="{
              hideIcon: isCollapse,
              isLine: isCollapse && route.path.includes(item.path),
            }"
          >
            <template #title>
              <SvgIcon :name="item.meta.icon" :size="16" color="#fff" />
              <span v-show="!isCollapse" style="margin-left: 4px">
                {{ item.meta.title }}
                <!-- 最外层 -->
              </span>
            </template>

            <template
              v-for="(v,i) in item.children.filter((a: any) => !a.meta.hidden)"
              :key="v.path + i"
            >
              <ElSubMenu :index="v.path" v-if="v.children?.length > 0">
                <template #title>
                  {{ v.meta.title }}
                  <!-- 二级子项并且拥有三级子项 -->
                </template>
                <span
                  v-for="vv in v.children.filter((a: any) => !a.meta.hidden)"
                  :key="vv.path"
                >
                  <a
                    v-if="vv.meta.target === '_blank'"
                    :index="vv.path"
                    :href="'/' + vv.path"
                  >
                    <ElMenuItem :key="vv.path">
                      {{ vv.meta.title }}
                      <!-- 三级子项 -->
                    </ElMenuItem>
                  </a>
                  <a
                    v-else
                    @click.prevent
                    @dragstart.prevent
                    :index="vv.path"
                    :key="vv.path"
                    :href="item.path + '/' + v.path + '/' + vv.path"
                  >
                    <ElMenuItem :index="vv.path" :key="vv.path">
                      {{ vv.meta.title }}
                      <!-- 三级子项 -->
                    </ElMenuItem>
                  </a>
                </span>
              </ElSubMenu>
              <a
                v-else-if="v.meta.target === '_blank'"
                :href="'/' + v.path"
                target="_blank"
              >
                <ElMenuItem>
                  {{ v.meta.title }}
                  <!-- 二级子项 -->
                </ElMenuItem>
              </a>
              <a
                v-else
                :href="item.path + '/' + v.path"
                @click.prevent
                @dragstart.prevent
              >
                <ElMenuItem :index="v.path">
                  {{ v.meta.title }}
                  <!-- 二级子项 -->
                </ElMenuItem>
              </a>
            </template>
          </ElSubMenu>
        </template>
      </ElScrollbar>
      <div class="menu-collapse">
        <ElButton @click="handleCollapse" type="primary">
          <SvgIcon name="expand" :size="24" color="#fff" />
        </ElButton>
      </div>
    </ElMenu>
    <ElContainer class="layout-container">
      <ElHeader class="layout-header">
        <div class="flex header">
          <ElBreadcrumb separator="/">
            <ElBreadcrumbItem>{{ $t("home", "首页") }}</ElBreadcrumbItem>
            <ElBreadcrumbItem
              v-for="(item, index) in breadcrumbList"
              :key="item.path"
            >
              <span :class="{ isActive: index === breadcrumbList.length - 1 }">
                {{ item.title }}
              </span>
            </ElBreadcrumbItem>
          </ElBreadcrumb>
          <div class="currency">
            <!-- <el-dropdown placement="bottom-end" @command="handleChange">
              <ElButton class="flex person">
                <span class="title-avatar"
                  ><span class="title-avatar">中/English</span></span
                >
              </ElButton>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="cn" class="person_dropdown_item">
                    中文
                  </el-dropdown-item>
                  <el-dropdown-item command="en" class="person_dropdown_item">
                    English
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown> -->
            <div class="currency_unit">
              【{{ userInfo.agencyCode }}】{{ userInfo.agencyName }}
            </div>
            <el-dropdown placement="bottom-end" @command="handleGo">
              <ElButton class="flex person">
                <SvgIcon name="avatar" :size="24" />
                <span class="title-avatar">
                  【{{ userInfo.account }}】{{ userInfo.roleName }}
                </span>
              </ElButton>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="a" class="person_dropdown_item">
                    {{ $t("userCenter", "个人中心") }}
                  </el-dropdown-item>
                  <el-dropdown-item command="b" class="person_dropdown_item">
                    {{ $t("logout", "退出登录") }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </ElHeader>
      <ElMain class="layout-main">
        <section class="main-container">
          <router-view v-slot="{ Component }">
            <template v-if="Component">
              <keep-alive :include="includeComponent">
                <component :is="Component" :key="$route.path" />
              </keep-alive>
            </template>
          </router-view>
        </section>
      </ElMain>
    </ElContainer>
  </ElContainer>
  <ElDialog
    v-model="dialogVisible"
    :title="$t('quitConfirm', '退出确认')"
    width="30%"
    :show-close="false"
  >
    <div class="tips-m">
      {{
        $t(
          "afterQuitYouNeedToLogInAgain",
          "退出后需重新登录，请确认是否退出当前登录"
        )
      }}
    </div>
    <template #footer>
      <span class="dialog-footer">
        <ElButton @click="dialogVisible = false">
          {{ $t("cancel", "取消") }}
        </ElButton>
        <ElButton type="primary" @click="confirm">
          {{ $t("confirm", "确定") }}
        </ElButton>
      </span>
    </template>
  </ElDialog>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, nextTick, onUnmounted } from "vue";
import usePiniaStore from "@/store/index";
import { useRouter, useRoute } from "vue-router";
import {
  ElContainer,
  ElMenu,
  ElSubMenu,
  ElMenuItem,
  ElButton,
  ElScrollbar,
  ElHeader,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElMain,
  ElDialog,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElNotification,
} from "element-plus";
import axios, { ResponseType } from "@/utils/request";
import SvgIcon from "@/components/SvgIcon.vue";

const { cityListStore, userStore, paymentStore } = usePiniaStore();
const router = useRouter();
const route = useRoute();
const isCollapse = ref(false);
const dialogVisible = ref(false);

// 读取 vuex
// const userInfo = computed(() => userStore.personInfo);
// const selectMenus = computed(() => store.state.user.selectMenus);
// const menuList = computed(() => store.state.user.menus);
// const breadcrumbList = computed(() => userStore.breadcrumbList);
// const includeComponent = computed(() => store.getters["user/includeComponent"]);

const userInfo = computed(() => userStore.personInfo);
const selectMenus = computed(() => userStore.selectMenus);
const menuList: any = computed(() => userStore.menus);
const breadcrumbList = computed(() => userStore.breadcrumbList);
const includeComponent = computed(() => userStore.includeComponent);
const msgIdList: any = ref([]);

// 保存BroadcastChannel实例的引用，用于清理
let broadcastChannel = ref<BroadcastChannel | null>(null);

onMounted(() => {
  const defaultV = route.meta.from as string;
  userStore.updateSelectMenus(defaultV);
  // 获取用户的权限和初始化菜单栏
  userStore.getMyRole();
  cityListStore.getCityList();
  // 获取用户的信息
  userStore.getPersonInfo();
  userStore.queryAgentUnitList();

  paymentStore.getPaymentOptionList(); // 更新交易方式
  // 手动刷新页面，更新菜单命中

  queryInnerMessage();

  // 使用 nextTick 确保组件完全挂载后再设置监听器
  nextTick(() => {
    // 增加额外延迟，确保所有同步代码执行完毕
    setupBroadcastListener();
  });
});

onUnmounted(() => {
  // 组件销毁时清理BroadcastChannel
  if (broadcastChannel.value) {
    broadcastChannel.value.close();
    broadcastChannel.value = null;
  }
});

/**
 * 设置 BroadcastChannel 监听器
 * 使用延迟处理机制确保消息有序性，避免与页面初始化产生竞态条件
 */
const setupBroadcastListener = () => {
  const senderTabId = sessionStorage.getItem("senderTabId");
  console.log("🚀 结束:", senderTabId);

  // 如果已存在channel实例，先清理
  if (broadcastChannel.value) {
    broadcastChannel.value.close();
    broadcastChannel.value = null;
  }

  broadcastChannel.value = new BroadcastChannel("reload_control");
  broadcastChannel.value.addEventListener("message", (event) => {
    if (event.data.type === "RELOAD_OTHER_TABS") {
      // 如果不是发送者，则处理重新加载指令
      if (event.data.senderTabId !== senderTabId) {
        console.log("收到重新加载指令，正在重新加载页面");
        location.reload(); // 如需要可以启用
      }
    }
  });
};

interface messageType {
  id: number;
  title: string;
  content: string;
  readStatus: number; //读状态：1-已读，0-未读
}
const queryInnerMessage = async () => {
  const res: ResponseType = await axios.get("/facade/sale/sitemsg/user/page");
  if (res.code === 0) {
    let message = "";
    res.data?.list.forEach((item: messageType) => {
      if (item.readStatus === 0 && msgIdList.value.length < 10) {
        message += `<p>${item.title}</p>`;
        msgIdList.value.push(item.id);
      }
    });
    if (msgIdList.value.length > 0) {
      ElNotification({
        title: "未读消息通知",
        message: message,
        dangerouslyUseHTMLString: true,
        position: "bottom-right",
        duration: 0,
        onClose: closeNotices,
        onClick: checkMsg,
      });
    }
  }
};

// 关闭消息通知弹窗-标记消息通知为已读
const closeNotices = async () => {
  const res: ResponseType = await axios.post("/facade/sale/sitemsg/user/read", {
    idList: msgIdList.value,
  });
  if (res.code === 0) {
    console.log("消息通知已读");
  }
};

const checkMsg = () => {
  router.push("/home/person-center");
};

const handleCollapse = () => {
  isCollapse.value = !isCollapse.value;
};

const handleselect = (key: string, keyPath: string[]) => {
  if (key === "/") return;
  const path = keyPath.join("/");
  // 打开查询+表单页面的刷新
  cityListStore.updateNeedReflash(true);
  // 点击同一个菜单
  if (router.currentRoute.value.path === path) {
    cityListStore.updateReflashNum();
  } else {
    router.push(path);
  }
};

const handleGo = (val: string) => {
  if (val === "a") {
    router.push("/home/person-center");
  } else {
    dialogVisible.value = true;
  }
};
const confirm = async () => {
  // const res: any = await axios.post("/facade/sale/login/out");
  const res: any = await axios.post("/facade/sale/agency/user/signOut");
  if (res.code === 0) {
    router.replace(`/login`); // 主动退出
    sessionStorage.setItem("redirectUrl", ""); // 清空
    localStorage.setItem("token_value", "");
  }
};
// const handleChange = (val: string) => {
//   const language: any = localStorage.getItem("language") || "cn";
//   if (val !== language) {
//     localStorage.setItem("language", val);
//     location.reload();
//   }
// };
</script>

<style lang="scss" scoped>
.content-layout {
  height: 100%;
  width: 100%;
}

.menu-list {
  display: flex;
  flex-direction: column;
}

.menu-title {
  height: 48px;
  font-weight: 500;
  font-size: 15px;
  line-height: 48px;
  padding: 0 28px;
}
.menu-scrollbar {
  flex: 1;
  overflow-x: hidden;
}

// 折叠状态下的滚动容器固定宽度
.menu-list.el-menu--collapse .menu-scrollbar {
  width: 64px;
}

.el-menu .el-menu--inline {
  transition: height 1s ease !important;
}
.logo {
  width: 100%;
  height: 76px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  p {
    line-height: 14px;
    font-size: 10px;
  }
}
.logo_title {
  width: 84px;
  height: 42px;
}
.menu-collapse {
  padding: 0 7px;
  height: 40px;
  line-height: 40px;
  margin-bottom: 15px;
  color: #fff;
}
.layout-container {
  min-width: 1250px;
}
.layout-header {
  height: 48px;
  background: #f8f9fa;
  border-bottom: 1px solid #eaecf1;
  box-shadow: 0px 1px 4px rgba(0, 21, 41, 0.12);
}
.header {
  height: 48px;
}
.person {
  border: none;
}

.layout-main {
  height: 100%;
  padding: 12px;
  padding-bottom: 0px;
  background-color: #f8f9fa; /* 与body背景色一致，更护眼 */
}
.main-container {
  height: 100%;
  border-radius: 4px;
  background-color: #f8f9fa;
  overflow: auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3); /* 添加轻微阴影提升层次感 */
}
::-webkit-scrollbar {
  height: 0;
  width: 0;
  color: transparent;
}
.title-avatar {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
  text-align: center;
  max-width: 300px; /* 设置最大宽度，可以根据需要调整 */
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 显示省略号 */
  display: inline-block; /* 或者 block，取决于布局需求 */
}
.isActive {
  color: #131414;
}

.falseCollapse {
  margin-left: 8px;
}

:deep(.hideIcon .el-sub-menu__title .el-icon) {
  display: none !important;
}

:deep(.el-sub-menu__title) {
  height: 36px;
}

:deep(.el-menu-item) {
  word-wrap: break-word;
  word-break: break-all;
}
.menu_max_width {
  height: 76px;
}
:deep(.el-sub-menu .el-menu-item) {
  height: auto !important;
  line-height: inherit !important;
  padding: 10px;
}
// .pl44 {
//   padding-left: 48px !important;
// } // 产品提出要显示出层级关系

// .currency-items {
//   margin-right: 24px;
// }
// .currency_unit {
//   margin-right: 24px;
//   font-weight: bold;
// }
// .ml28 {
//   margin-left: 8px;
// }
.isLine {
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 2px;
    height: 30px;
    transform: translateY(-50%);
    background-color: #fff;
  }
}
a {
  text-decoration: none !important;
  color: inherit !important;
}
.currency {
  display: flex;
  align-items: center;
}
.currency_unit {
  margin-right: 24px;
  font-weight: bold;
}

:deep(.el-menu--inline > a),
:deep(.el-menu--inline > span) {
  display: block;
}
</style>
